import { IDuplicateModalState, TDuplicatePost } from './types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { duplicatePostThunk, getAllowedSocialsToDuplicatePostThunk, getAllowedToDuplicatePostThunk } from './thunks'
import { POST_TYPE, SOCIAL_NETWORK } from '../../../models/post'

const initialState: IDuplicateModalState = {
  postForDuplicate: {
    social_networks: [],
    post_social_id: 0
  },
  allowedSocials: [],
  duplicatedPost: null,
  // TODO change it when content page will work with store data. It just for content page after the post was duplicated
  isDuplicateModalOpen: false,
  isGettingAllowedSocials: false
}

const duplicateModaltSlice = createSlice({
  name: 'duplicatePost',
  initialState,
  reducers: {
    toggleIsOpenDuplicateModal: (state) => {
      state.isDuplicateModalOpen = !state.isDuplicateModalOpen
    },
    removeSelectedSocialFromPost: (state, action: PayloadAction<SOCIAL_NETWORK>) => {
      const social = action.payload
      const { social_networks } = state.postForDuplicate
      const socialIndex = social_networks.findIndex((socialNetwork) => socialNetwork === social)
      social_networks.splice(socialIndex, 1)
      state.postForDuplicate.social_networks = social_networks
    },
    setDuplicatedPostAction: (state, action) => {
      state.duplicatedPost = action.payload
    },
    addSelectedSocialToPost: (state, action: PayloadAction<SOCIAL_NETWORK>) => {
      const social = action.payload
      state.postForDuplicate.social_networks.push(social)
    },
    setPostsForDuplicate: (state, action: PayloadAction<TDuplicatePost>) => {
      state.postForDuplicate = action.payload
      state.isDuplicateModalOpen = true
    },
    resetDuplicateStateAction: (state) => {
      state.isDuplicateModalOpen = false
      state.postForDuplicate = {
        social_networks: [],
        post_social_id: 0
      }
      // state.allowedSocials = []
      state.isGettingAllowedSocials = false
    },
    closeDuplicateModalAction: (state) => {
      state.isDuplicateModalOpen = false
      // state.allowedSocials = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(duplicatePostThunk.pending, (state, action) => {})
    builder.addCase(duplicatePostThunk.fulfilled, (state, action) => {
      state.isDuplicateModalOpen = false
      state.postForDuplicate = Object.assign({}, initialState.postForDuplicate)
    })
    builder.addCase(duplicatePostThunk.rejected, (state, action) => {})
    builder.addCase(getAllowedSocialsToDuplicatePostThunk.pending, (state, action) => {
      state.isGettingAllowedSocials = true
    })
    builder.addCase(
      getAllowedSocialsToDuplicatePostThunk.fulfilled,
      (state, action: PayloadAction<{ allowed_social_networks: SOCIAL_NETWORK[] }>) => {
        state.isGettingAllowedSocials = false
        state.allowedSocials = Object.values(action.payload.allowed_social_networks)
      }
    )
    builder.addCase(getAllowedSocialsToDuplicatePostThunk.rejected, (state, action) => {
      state.isGettingAllowedSocials = false
      state.allowedSocials = []
    })

    builder.addCase(getAllowedToDuplicatePostThunk.pending, (state, action) => {
      state.isGettingAllowedSocials = true
    })
    builder.addCase(
      getAllowedToDuplicatePostThunk.fulfilled,
      (state, action: PayloadAction<{ allowed_social_networks: SOCIAL_NETWORK[] }>) => {
        state.isGettingAllowedSocials = false
        state.allowedSocials = Object.values(action.payload.allowed_social_networks)
      }
    )
    builder.addCase(getAllowedToDuplicatePostThunk.rejected, (state, action) => {
      state.isGettingAllowedSocials = false
      state.allowedSocials = []
    })
  }
})

export const {
  toggleIsOpenDuplicateModal,
  setPostsForDuplicate,
  setDuplicatedPostAction,
  resetDuplicateStateAction,
  closeDuplicateModalAction,
  removeSelectedSocialFromPost,
  addSelectedSocialToPost
} = duplicateModaltSlice.actions
export default duplicateModaltSlice.reducer
